declare global {
    interface Window {
        run_page_script: () => void;
		dacssmartfund: ( functions: { build_loadomatic } ) => void;
    }
}

import 'focus-visible';
import { animateItemsIn, animateItemsOut } from './vendor/nav-anim.js';

import './vendor/ajax.js';
import { LoadOMatic } from './vendor/load-o-matic.js';

export * from './CookieConsentManager.js';


( () => {
	const nav = document.querySelector( '.nav' );
	const focusable_selectors = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

	let focusable_elements = [];
	let first_el;
	let last_el;

	function trapFocus( e ) {
		if ( e.key === 'Escape' ) {
			document.body.classList.remove( 'menu--open' );
			disableFocusTrap();
			animateItemsOut( document.querySelectorAll( '.nav' ) );
		}

		if ( e.key !== 'Tab' ) {
			return;
		}

		// Requery in case DOM changes
		focusable_elements = Array.from( nav.querySelectorAll( focusable_selectors ) ) as Element[];

		// Include menu button in focusable elements if it exists
		const menu_button = document.querySelector( '.menu-button' );

		if ( menu_button ) {
			focusable_elements.unshift( menu_button );
		}

		first_el = focusable_elements[0];
		last_el = focusable_elements[focusable_elements.length - 1];

		if ( e.shiftKey ) {
			if ( document.activeElement === first_el ) {
				e.preventDefault();
				last_el.focus();
			}
		} else {
			if ( document.activeElement === last_el ) {
				e.preventDefault();
				first_el.focus();
			}
		}
	}

	function enableFocusTrap() {
		nav.removeAttribute( 'aria-hidden' );
		nav.removeAttribute( 'inert' );

		focusable_elements = Array.from( nav.querySelectorAll( focusable_selectors ) ) as Element[];
		first_el = focusable_elements[0];
		last_el = focusable_elements[focusable_elements.length - 1];

		document.addEventListener( 'keydown', trapFocus );
		first_el?.focus();
	}

	function disableFocusTrap() {
		// Move focus away to avoid aria-hidden conflict
		if ( nav.contains( document.activeElement ) ) {
			( document.activeElement as HTMLElement )?.blur();
			// Optionally, move focus to a safe fallback (like the toggle button or body)
			document.body.focus();
		}
		nav.setAttribute( 'aria-hidden', 'true' );
		nav.removeAttribute( 'inert' );
		document.removeEventListener( 'keydown', trapFocus );
	}

	function doToggle( toggler ) {
		const togglees = document.querySelectorAll( toggler.getAttribute( 'data-togglees' ) );
		const is_toggled = document.body.classList.toggle( 'menu--open' );

		if ( is_toggled ) {
			enableFocusTrap();
			animateItemsIn( togglees );
		} else {
			disableFocusTrap();
			animateItemsOut( togglees );
		}
	}

	window.addEventListener( 'click', ( event ) => {
		const target = event.target as HTMLElement;
		const toggler = target.closest( '.menu' );
		if ( !toggler ) {
			return;
		}
		doToggle( toggler );
	} );
} )();

( () => {
	const postcode_form = document.querySelector( '#postcode-form' );

	if ( !postcode_form ) {
		return;
	}

	// Form submission handler
	document.getElementById( 'postcode-form' ).addEventListener( 'submit', ( event ) => {
		event.preventDefault(); // Prevent form from reloading the page
		const postcode = ( document.getElementById( 'postcode' ) as HTMLInputElement ).value;
		const api_key = 'ErjSjHEmrXE5GUgmTPFiAteK';
		const url = `https://www.theyworkforyou.com/api/getMP?key=${api_key}&postcode=${postcode}`;
		// Clear the previous MP information
		// document.getElementById('mp-info').textContent = 'Loading...';
		// Fetch the data from the API
		fetch( url )
			.then( response => response.json() )
			.then( data => {
				const encoded_name = data.full_name.replace( / /g, '%20' );
				const url2 = 'https://members-api.parliament.uk/api/Members/Search?Name=' + encoded_name + '&skip=0&take=20';
				// Fetch the data from the API 2
				fetch( url2 )
					.then( response => response.json() )
					.then( data2 => {
						const mp_id = data2.items[0].value.id;
						const url3 = 'https://members-api.parliament.uk/api/Members/' + mp_id + '/Contact';
						fetch( url3 )
							.then( response => response.json() )
							.then( data3 => {
								let mp_email = '';
								data3.value.forEach( ( item ) => {
									if ( item.email ) {
										mp_email = item.email;
										document.getElementById( 'mp-info2' ).innerHTML = `${mp_email}`;
									}
								} );
								//Show results box
								document.querySelector( '.mp-api__result' ).classList.add( 'is-visible' );
							} )
							.catch( () => {
								document.getElementById( 'mp-info' ).textContent = 'Error loading data 2';
							} );
					} )
					.catch( () => {
						document.getElementById( 'mp-info' ).textContent = 'Error loading data 2';
					} );
				// Check if data contains the expected fields
				if ( data.full_name && data.constituency && data.party ) {
				// Display only full_name, constituency, and party
					document.getElementById( 'mp-info' ).innerHTML = `
				${data.full_name}<br>
				${data.constituency}<br>
				${data.party}
				`;
					document.querySelector( '.thempname' ).textContent = data.full_name;
					document.querySelectorAll( '.theconstituencyname' ).forEach( el => {
						el.textContent = data.constituency;
					} );
					( document.querySelector( '.theyourname' ) as HTMLElement ).textContent = ( document.getElementById( 'yourname' ) as HTMLInputElement ).value;
					( document.querySelector( '.thejobname' ) as HTMLElement ).textContent = ( document.getElementById( 'jobtitle' ) as HTMLInputElement ).value;

				} else {
					document.getElementById( 'mp-info' ).textContent = 'MP information not found.';
				}
			} )
			.catch( () => {
				document.getElementById( 'mp-info' ).textContent = 'Error loading data';
			} );
	} );
} )();

( () => {
	const copytoclipboard = document.getElementById( 'copytoclipboard' );

	if ( !copytoclipboard ) {
		return;
	}
	document.addEventListener( 'DOMContentLoaded', () => {
		// Function to copy text to clipboard
		document.getElementById( 'copytoclipboard' ).addEventListener( 'click', ( event ) => {
			event.preventDefault();
			// Get the text content from the email subject and body
			const subject = document.getElementById( 'email_subject' ).innerText;
			const body = document.getElementById( 'email_body' ).innerText;
			// Create a string to copy (e.g., include both subject and body)
			const text_to_copy = `Subject: ${subject}\n\nBody: ${body}`;
			// Use navigator.clipboard to copy the text
			navigator.clipboard.writeText( text_to_copy ).then( () => {
			// Success feedback
				document.getElementById( 'copy-feedback' ).textContent = 'Text copied to clipboard!';
			} ).catch( ( err ) =>  {
			// Error feedback
				document.getElementById( 'copy-feedback' ).textContent = 'Failed to copy text: ' + err;
			} );
		} );
		// Add an event listener to the 'Email Your MP' button
		document.querySelectorAll( '.email_your_mp' ).forEach( button => {
			button.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				const subject = encodeURIComponent( document.getElementById( 'email_subject' ).textContent || '' );
				const body = encodeURIComponent( document.getElementById( 'email_body' ).innerText.trim() );
				const theemail = encodeURIComponent( document.getElementById( 'mp-info2' ).textContent || '' );
				const mail_to_link = `mailto:${theemail}?subject=${subject}&body=${body}`;
				window.location.href = mail_to_link;
			} );
		} );
	} );
} )();

( () => {
	const copytoclipboard = document.getElementById( 'copytoclipboard' );

	if ( !copytoclipboard ) {
		return;
	}
	document.getElementById( 'copytoclipboard' ).addEventListener( 'click', ( event ) => {
		event.preventDefault();
		const subject = document.getElementById( 'email_subject' ).innerText;
		const body = document.getElementById( 'email_body' ).innerText;
		const text_to_copy = `Subject: ${subject}\n\nBody: ${body}`;
		navigator.clipboard.writeText( text_to_copy ).then( () =>  {
			const tooltip = document.getElementById( 'copy-feedback' );
			if ( tooltip ) {
				tooltip.textContent = 'Copied!';
				tooltip.classList.add( 'visible' );
				setTimeout( () => tooltip.classList.remove( 'visible' ), 3000 );
			}
		} ).catch( () => {
			const tooltip = document.getElementById( 'copy-feedback' );
			if ( tooltip ) {
				tooltip.textContent = 'Failed to copy';
				tooltip.classList.add( 'visible' );
				setTimeout( () => tooltip.classList.remove( 'visible' ), 3000 );
			}
		} );
	} );
} )();

const build_loadomatic = ( options ) => {
	// Load more
	const container = document.querySelector( '.loadomatic' );
	if ( !container ) {
		return;
	}
	const loadomatic = new LoadOMatic( options );

	if ( window.CustomEvent ) {
		loadomatic.addCallback( () => {
			window.dispatchEvent( new CustomEvent(
				'loadomatic-loaded'
			) );
		} );
	}

	loadomatic.trigger.classList.remove( 'loadomatic__trigger--hidden' );
	loadomatic.trigger.addEventListener( 'click', () => {
		loadomatic.loadMore();
	} );
};

window.run_page_script = () => {
	if ( typeof window.dacssmartfund === 'function' ) {
		window.dacssmartfund( {
			build_loadomatic: build_loadomatic
		} );
	}
};
window.run_page_script();
